const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;
const MS_PER_WEEK = 7 * MS_PER_DAY;

const RELATIVE_THRESHOLDS = [
    { limitMs: MS_PER_MINUTE, formatter: () => 'just now' },
    {
        limitMs: MS_PER_HOUR,
        formatter: (diffMs: number) => `${Math.round(diffMs / MS_PER_MINUTE)}m ago`
    },
    {
        limitMs: MS_PER_DAY,
        formatter: (diffMs: number) => `${Math.round(diffMs / MS_PER_HOUR)}h ago`
    },
    {
        limitMs: MS_PER_WEEK,
        formatter: (diffMs: number) => `${Math.round(diffMs / MS_PER_DAY)}d ago`
    }
];

export function formatRelative(iso: string): string {
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return '';
    const diffMs = Math.max(0, Date.now() - then);
    for (const threshold of RELATIVE_THRESHOLDS) {
        if (diffMs < threshold.limitMs) return threshold.formatter(diffMs);
    }
    return `${Math.round(diffMs / MS_PER_DAY)}d ago`;
}

export function formatShortDate(iso: string): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** Compact duration for journey segments: '<1h', '5h', '3d', '2w 3d'. */
export function formatDurationMs(durationMs: number): string {
    if (durationMs < MS_PER_HOUR) return '<1h';
    if (durationMs < MS_PER_DAY) return `${Math.round(durationMs / MS_PER_HOUR)}h`;
    const days = Math.floor(durationMs / MS_PER_DAY);
    if (days < 14) return `${days}d`;
    const weeks = Math.floor(days / 7);
    const rest = days % 7;
    return rest > 0 ? `${weeks}w ${rest}d` : `${weeks}w`;
}
